import { hasAnyOfRoles } from 'utils/AccountRoles';
import { useUser } from '~/authentication/store';

type BackLink = {
  url: string;
  label: string;
};

const useBackLink = (): BackLink => {
  const { user } = useUser();
  const userInOnboarding = hasAnyOfRoles(user?.roles, [
    'onboarding_host',
    'onboarding_host_webinar',
  ]);

  if (userInOnboarding) {
    return {
      url: `${BECOME_A_HOST_HOST}/overview`,
      label: 'Continue Onboarding',
    };
  }

  return {
    url: '/host/profile/',
    label: 'Back to profile',
  };
};

export default useBackLink;
